import React, { useEffect, useState } from "react";
import AxiosInstance from "../../../../AxiosInstance";
import { Button, Checkbox, Modal, Table, message } from "antd";

export default function InvestorView({ data: propData }) {
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  var [dataSource, setDataSource] = useState([]);
  const [selectedInvestors, setSelectedInvestors] = useState([]);

  const isInvestorSelected = (investorNumber) => {
    return selectedInvestors.includes(investorNumber);
  };

  // Function to handle checkbox toggle
  const toggleinvestorSelection = (investorNumber) => {
    setSelectedInvestors(
      (prevSelected) =>
        prevSelected.includes(investorNumber)
          ? prevSelected.filter((num) => num !== investorNumber) // Remove if exists
          : [...prevSelected, investorNumber] // Add if not exists
    );
  };
  useEffect(() => {
    getTableData(0);
  }, []);

  const getTableData = async (skip) => {
    const url = `partner/investor/list?skip=${skip}&take=10`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;

        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      })
      .catch((err) => {});
  };
  const sendRefferal = async () => {
    if (!Array.isArray(selectedInvestors) || selectedInvestors.length === 0) {
      console.error("Investor IDs must be a non-empty array.");
      return;
    }

    setLoading(true);

    // Construct the query parameter string for investor IDs
    const investorIdParams = selectedInvestors
      .map((id) => `investorIds=${id}`)
      .join("&");

    const url = `/export/portfolio?portfolioId=${propData.portfolioId}&isSendEmail=true&${investorIdParams}`;

    try {
      const resp = await AxiosInstance().get(url);
      let { data } = resp;

      Modal.success({
        content: "Refferal Sent Successfully",
        onOk: () => {
          window.location.reload();
        },
      });
      // Process response if needed
      // console.log("Response:", data);
    } catch (err) {
      message.error(err?.response?.data?.message);
      console.error("Error sending referral:", err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Action",
      align: "center",
      render: (text, investor) => (
        <>
          <Checkbox
            checked={isInvestorSelected(investor.userId)}
            onChange={() => toggleinvestorSelection(investor.userId)}
          />
        </>
      ),
    },
    {
      title: "Investor Name",
      dataIndex: "investor",
      key: "investor",
      align: "center",
      render: (text, investor) => (
        <>
          {investor?.firstName} {investor?.lastName}
        </>
      ),
    },
    {
      title: "Phone Number",

      align: "center",
      render: (text, investor) => <>{investor.phoneNumber}</>,
    },
    {
      title: "State",

      align: "center",
      render: (text, investor) => <>{investor.statename}</>,
    },
    {
      title: "Investor Email",
      dataIndex: "investor",
      key: "investor",
      align: "center",
      render: (text, investor) => <>{investor.email}</>,
    },
  ];
  const change = (data) => {
    getTableData((data - 1) * 10);
  };

  return (
    <>
      <Button
        className=""
        disabled={selectedInvestors.length === 0}
        onClick={() => {
          sendRefferal();
        }}
      >
        Send Referral
      </Button>{" "}
      <Table
        bordered={true}
        scroll={{ x: 400 }}
        loading={loading}
        className="table"
        dataSource={[...dataSource]}
        columns={columns}
        pagination={{
          pageSize: 10,
          total: paginationMetaData.count,
          onChange: change,
        }}
      />
    </>
  );
}
